import { BoxProps } from "@mui/material"
import React from "react"
import { useTranslation } from "react-i18next"
import { useMediaQuery } from "react-responsive"

import { Box, Typography } from "src/UILibrary"
import InputTextField from "./InputTextField"

type Props = {
  sx?: BoxProps
  name: string
  required?: boolean
  companyName: string
  handleCompanyName: any
  companyNameJP: string
  handleCompanyNameJP: any
  validationMessage?: string
}

const InputCompanyField = ({
  sx,
  name,
  required,
  companyName,
  handleCompanyName,
  companyNameJP,
  handleCompanyNameJP,
  validationMessage,
}: Props) => {
  const { t } = useTranslation("translation", { keyPrefix: "signup" })

  const isPC = useMediaQuery({ query: "(min-width: 850px)" })

  const style = sx || {}
  return (
    <Box
      sx={{
        width: isPC ? "800px" : "100%",
        mr: "auto",
        ml: 0,
        ...style,
      }}
    >
      <Box display="flex">
        <Typography.SubHeadNormal sx={{ mr: "10px", mb: "10px" }}>{name}</Typography.SubHeadNormal>
        {required && (
          <Box
            sx={{
              px: "8px",
              borderWidth: "1px",
              borderStyle: "solid",
              borderRadius: "4px",
              borderColor: "text.border",
              display: "flex",
            }}
          >
            <Typography.InputFieldRequired sx={{ m: "auto", color: "text.border" }}>
              {t("required")}
            </Typography.InputFieldRequired>
          </Box>
        )}
      </Box>
      <InputTextField
        name={t("company_name")}
        sx={{ width: isPC ? "355px" : "100%" }}
        placeholder={t("input_normal_string")}
        text={companyName}
        handleText={handleCompanyName}
        maxLength={100}
      ></InputTextField>
      <InputTextField
        name={t("company_name_jp")}
        sx={{ width: isPC ? "355px" : "100%" }}
        placeholder={t("input_normal_string")}
        text={companyNameJP}
        handleText={handleCompanyNameJP}
        maxLength={100}
      ></InputTextField>
      {validationMessage && (
        <Box sx={{ height: "20px", pt: "5px", mt: "-20px" }}>
          <Typography.ValidationText>{validationMessage}</Typography.ValidationText>
        </Box>
      )}
    </Box>
  )
}

export default InputCompanyField
